import axios from 'axios'
let url=window.location.origin+'/PCwebsite/app'
console.log(window.location.origin);
const instance = axios.create({
    //  baseURL:'http://hsybyy.cn',
    //  http://sanyayibenyuan.com/PCwebsite/app',//https://hbrsyyyxgs.com http://www.shenhaoyaoye.com http://ysxyygs.com
    // baseURL: 'http://nmgqiufei.com.cn/PCwebsite/app',
      baseURL: url,
    // baseURL: '/api',
    timeout: 100000
});

//添加请求拦截器，会在发起请求之前执行相应的需求
instance.interceptors.request.use(function(config) {
   
    let token = sessionStorage.getItem("token")
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;

}, function(error) {
    return Promise.reject(error);
});

//添加响应拦截器，会在返回数据后先执行相应的需求
instance.interceptors.response.use(function(response) {
    // console.log('res', response);
    let { code } = response.data
    if (code === 401) {
        //token失效
        sessionStorage.clear() //清除sessionStorage
        window.location.reload() //页面刷新 回到登录页面
    }
    return response;
}, function(error) {
    console.log('res-err', error);
    let { code } = error
    if (code === 'ERR_NETWORK') {
        alert('网络连接失败')
    }
    return Promise.reject(error);
});
export default instance


// WEBPACK FOOTER //
// ./src/api/index.js